import { Badge, Button } from "antd";
import "./styles/index.scss";
import { useOrderList } from "../../../context/OrderListContext";
import { useMemo } from "react";
import ShoppingCartOutlined from "@ant-design/icons/lib/icons/ShoppingCartOutlined";

interface Props {
  setOpen: (val: boolean) => void;
}

function HeaderBtnShoppingCard(props: Props) {
  const { setOpen } = props;

  const { orderList } = useOrderList();

  const totalOrderItem = useMemo(() => {
    return orderList.reduce((sum, item) => sum + item.quantity, 0);
  }, [orderList]);

  return (
    <div className="header-btn" onClick={() => setOpen(true)}>
      <Badge count={totalOrderItem}>
        <Button
          icon={<ShoppingCartOutlined />}
          style={{
            fontSize: "18px",
            border: " none",
            padding: "4px",
          }}
        ></Button>
      </Badge>
      <span className=" header-btn-action-label">Giỏ hàng</span>
    </div>
  );
}

export default HeaderBtnShoppingCard;
